import { render, staticRenderFns } from "./OrderItemParameters.vue?vue&type=template&id=8c6af612&scoped=true&"
import script from "./OrderItemParameters.vue?vue&type=script&lang=js&"
export * from "./OrderItemParameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6af612",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c6af612')) {
      api.createRecord('8c6af612', component.options)
    } else {
      api.reload('8c6af612', component.options)
    }
    module.hot.accept("./OrderItemParameters.vue?vue&type=template&id=8c6af612&scoped=true&", function () {
      api.rerender('8c6af612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/Admin/OrderItemParameters.vue"
export default component.exports